/*global themeVars */

const instanceVars = themeVars;
const { ajaxUrl } = instanceVars

// Module Pattern with IIFE,
const abSmartlyModule = ( () => {


	/**
	 * Retrieves the value of a cookie by name from the document's cookies.
	 *
	 * @param {string} cookieName - The name of the cookie to retrieve.
	 * @return {string|undefined} The value of the specified cookie, or undefined if the cookie is not found.
	 */
	function getCookie( cookieName ) {

		// Match the cookie name followed by anything except a semicolon
		const match = document.cookie.match( `(^|;)\\s*${cookieName}\\s*=\\s*([^;]*)` );
		return match ? decodeURIComponent( match[2] ) : undefined;

	}

	/**
	 * Appends a parameter to the current URL
	 * @param {HTMLAnchorElement} urlSource - The element with href.
	 * @param {string} paramName - The name of the parameter
	 * @param {string} paramValue - The value of the parameter
	 * @return {string} - The new URL with the parameter added
	 */
	function appendParameterToUrl( urlSource, paramName, paramValue ) {

		// Get the current URL
		const url = new URL( urlSource.href );

		// Set the parameter (will update if it already exists)
		url.searchParams.set( paramName, paramValue );

		// Return the new URL as a string
		return url.toString();

	}

	return {
		/**
		 * Function to initialize the AB Smartly track and show content from the variant value.
		 *
		 * This function checks page for a specific block in the document.
		 * If the blocks is found, it creates event in ABsmartly and check what version of content to show.
		 * The request is sent to the server using the Fetch API. Return information is unique ID and variant value.
		 * Unique ID is stored in a cookie and variant value is used to show the content.
		 */
		init: () => {

			const abSmartlyBlock = document.querySelector( '.b-absmartly' );

			if ( abSmartlyBlock ) {

				const absUniqueId = getCookie( 'abs_unique_id' );
				const absVariantValue = getCookie( 'abs_variant_value' );

				if ( absVariantValue ) {

					const blocks = document.querySelectorAll( `.${absVariantValue}` );
					blocks.forEach( block => {

						block.style.display = 'block';

					} );

				}

				fetch( ajaxUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
					body: new URLSearchParams( {
						action: 'abs_init',
						userAgent: navigator.userAgent,
						browserLanguage: navigator.language,
						userUniqueId: absUniqueId,
						nonce: instanceVars.security
					} ),
				} )
					.then( response => response.json() )
					.then( data => {

						if ( data.success ) {

							if ( absUniqueId !== data.userUniqueId || absVariantValue !== data.variantValue ) {

								// Set the cookies with the new values or expire.
								const secure = window.location.protocol === 'https:' ? '; secure' : '';
								document.cookie = `abs_unique_id=${data.userUniqueId}; path=/; max-age=${60 * 60 * 24 * 30}${secure}; SameSite=Lax`;
								document.cookie = `abs_variant_value=${data.variantValue}; path=/; max-age=${60 * 60 * 24 * 30}${secure}; SameSite=Lax`;

							}

							if ( absVariantValue !== data.variantValue ) {

								// Hide items that are not in the variant based on start cookie
								const allOtherVariants = document.querySelectorAll( `.b-absmartly:not(.${data.variantValue})` );
								allOtherVariants.forEach( block => {

									block.style.display = 'none';

								} );

								// Show items that are in the variant from ABsmartly
								const blocks = document.querySelectorAll( `.${data.variantValue}` );
								blocks.forEach( block => {

									block.style.display = 'block';

								} );

							}

						} else {

							// If the request fails, we can show default A block
							const blocks = document.querySelectorAll( '.b-absmartly-a' );
							blocks.forEach( block => {

								block.style.display = 'block';

							} );

						}

					} );

			}

		},

		/**
		 * Function to handle a click event on a specific button, and send a POST request to track the button click.
		 *
		 * This function will find the primary custom button on the page and attach a click event listener to it.
		 * When the button is clicked, a POST request will be sent to the specified ajax URL.
		 * The request includes the necessary action to track the button click.
		 */
		buttonClick: () => {

			const buttons = document.querySelectorAll( 'a.try-for-free, .wp-block-button.try-for-free > .wp-block-button__link' );

			if ( buttons ) {

				buttons.forEach( button => {

					button.addEventListener( 'click', ( event ) => {

						const absUniqueId = getCookie( 'abs_unique_id' );

						if ( absUniqueId ) {

							event.preventDefault();
							window.location.href = appendParameterToUrl( button, 'partner_user_id', absUniqueId );

						}

						fetch( ajaxUrl, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded',
							},
							body: new URLSearchParams( {
								action: 'abs_track_button_click',
								userAgent: navigator.userAgent,
								browserLanguage: navigator.language,
								buttonId: button.id,
								userUniqueId: absUniqueId,
								nonce: instanceVars.security
							} ),
						} )
							.then( response => response.json() );

					} );

				} );

			}

		}
	};

} )();

export const abSmartlyInit = abSmartlyModule.init;
export const abSmartlyButtonClick = abSmartlyModule.buttonClick;


